import React, { useRef, useState } from 'react';
import { LANGUAGE_ENUMS } from '../../../../constants/staticPageConstants';
import { UpTick } from '../../../Icons/upTick';
import { useOnClickOutside } from '../../../hooks';
import useOnHoverOutside from '../../../hooks/use-hover-outside';
import { ChildProps } from './DropdownOptionsComponent';

export type TDropdownList = Array<{
  name: string;
  name_ar?: string;
  link: string;
}>;
export type TDropdownElement = {
  activeState: boolean;
  multiColdDropdownList?: Array<{
    name: string;
    url: string;
    child: Array<ChildProps>;
  }>;
  dropdownList?: TDropdownList;
  language?: string;
  logoutFunction?: () => void;
  dropdownData?: Record<string, string>[];
  topMenu?: boolean;
};
export interface TDropdown {
  dropdownLabel: string;
  Dropdown?: React.ElementType<TDropdownElement>;
  classes?: string;
  dropdownDefaultState?: boolean;
  logoutFunction?: () => void;
  hover?: boolean;
  multiColDropdownList?: Array<ChildProps>;
  dropdownList?: TDropdownList;
  language?: LANGUAGE_ENUMS;
  domain?: string;
  openSidebar?: () => void;
  dropdownData?: Record<string, string>[];
  topMenu?: boolean;
}

const DropdownComponent = ({
  dropdownLabel,
  dropdownData,
  Dropdown,
  classes,
  logoutFunction,
  dropdownDefaultState = false,
  dropdownList,
  multiColDropdownList,
  language = LANGUAGE_ENUMS.English,
  domain = 'in',
  hover = false,
  openSidebar,
  topMenu = false,
}: TDropdown): JSX.Element => {
  const [dropdownState, setDropdownState] = useState(dropdownDefaultState);

  const ref = useRef(null);

  const toggleFunction = () => {
    setDropdownState(!dropdownState);
    openSidebar && openSidebar();
  };

  useOnClickOutside(ref, () => {
    setDropdownState(false);
  });
  useOnHoverOutside(ref, () => {
    setDropdownState(false);
  });
  const setDropdownStateTrue = () => {
    setDropdownState(true);
  };

  return (
    <div ref={ref} className={classes}>
      <button
        type="button"
        className={
          'font-medium inline-flex w-auto py-2 rounded text-font-500 transition duration-150 ease-in-out whitespace-nowrap items-center justify-start sm:w-full sm:justify-between focus:outline-none pr-5' +
          (domain === 'sa' ? ' text-s-14' : '')
        }
        id="menu-button"
        aria-expanded="true"
        aria-haspopup="true"
        onClick={toggleFunction}
        // onMouseEnter={setDropdownStateTrue}
        {...(hover ? { onMouseEnter: setDropdownStateTrue } : {})}
      >
        {dropdownLabel}
        <span className={`${dropdownState ? 'rotate-180' : ''} px-2`}>
          <UpTick colorCode="#596C85" />
        </span>
      </button>
      {Dropdown ? (
        <Dropdown
          activeState={dropdownState}
          logoutFunction={logoutFunction}
          dropdownList={
            dropdownList || (multiColDropdownList as unknown as TDropdownList)
          }
          language={language}
          dropdownData={dropdownData}
          topMenu={topMenu}
        />
      ) : null}
    </div>
  );
};

export { DropdownComponent };
